import * as types from './types';

export const refreshWholesalers = () => ({
  type: types.CHANGE_WHOLESALERS_VERSION
});
